import { Component, inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { compare } from "fast-json-patch";
import { finalize } from "rxjs/operators";
import { CstPdfViewerPopupComponent } from "src/app/common-components/file-viewers/pdf-viewer/popup/pdf-viewer-popup.component";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";
import {
  FormulareClientProvider,
  FormularDetailDto,
  PdfResult,
} from "src/app/web-api/web-api";

export interface ITaskFormularUpdateData {
  id: string;
  beschreibung?: string;
  anlageNr?: string;
}

@Component({
    templateUrl: "./task-formular-update.component.html",
    styleUrls: ["./task-formular-update.component.scss"],
    standalone: false
})
export class TaskFormularUpdateComponent extends CstResponsivePopupComponentBase<
  ITaskFormularUpdateData,
  FormularDetailDto
> {
  private _client = inject(FormulareClientProvider);
  private _popupService = inject(CstResponsivePopupService);

  private _origValue = null;
  public loading = true;
  public bezeichnung = "";
  public form: FormGroup;
  public pdfs: PdfResult[];
  public currentPdfIdx = 0;

  constructor() {
    const fb = inject(FormBuilder);

    super();
    this.form = fb.group({
      id: ["", Validators.required],
      vorlageID: ["", Validators.required],
      taskID: [""],
      beschreibung: [""],
      anlageNr: [""],
      xmlDocument: [""],
    });
  }

  public onInitialised(): void {
    if (!this.data?.id) {
      this.popupRef.close(null);
      throw new Error(
        "You must provide an id when calling TaskFormularUpdateComponent"
      );
    }
    this.loading = true;
    this._client
      .getSingle(this.data.id, false)
      .pipe(finalize(() => (this.loading = true)))
      .subscribe((result) => {
        this.bezeichnung = result.bezeichnung;
        this.pdfs = result.pdfs;
        this.form.patchValue(result); // Form mit den tatsächlichen Daten der Result vorbelegen
        this.form.patchValue(this.data); // Dann ggf. mit übergebenen Daten überschreiben
        this._origValue = { ...this.form.value };
      });
  }

  public onAccept(): void {
    if (!this.form.valid) {
      return;
    }

    const val = { ...this.form.value };
    const patch = compare(this._origValue, val);
    if (patch.length === 0) {
      this.close();
      return;
    }
    const cmd = {
      id: val.id,
      patch,
    };
    console.log(cmd);
    this._client.patch(cmd as any).subscribe(
      (result) => {
        this.popupRef.close(result);
      },
      (error) => console.log(error)
    );
  }

  public onCancel() {
    this.popupRef.close(null);
  }

  public onPreviewBefore() {
    if (--this.currentPdfIdx < 0) {
      this.currentPdfIdx = this.pdfs.length - 1;
    }
  }
  public onPreviewNext() {
    if (++this.currentPdfIdx >= this.pdfs.length) {
      this.currentPdfIdx = 0;
    }
  }
  public onPreviewPopup() {
    this._popupService.open(CstPdfViewerPopupComponent, {
      data: {
        src: this.pdfs[this.currentPdfIdx].data,
        title: this.pdfs[this.currentPdfIdx].label,
      },
      maxHeight: "96vh",
    });
  }
}
